import { styled } from '@mui/material/styles'

export const InstallPwaBannerRoot = styled('aside')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 1.5),
  marginBottom: theme.spacing(1.5),
  backgroundColor: '#1a1a1a',
  color: '#fff',
  borderRadius: 8,
}))

export const InstallPwaBannerText = styled('p')({
  margin: 0,
  flex: '1 1 200px',
  fontSize: 14,
  lineHeight: 1.4,
})

export const InstallPwaBannerInstallButton = styled('button')(({ theme }) => ({
  border: 0,
  borderRadius: 6,
  padding: theme.spacing(0.75, 1.5),
  backgroundColor: '#e53935',
  color: '#fff',
  fontWeight: 600,
  cursor: 'pointer',
}))

export const InstallPwaBannerCloseButton = styled('button')(({ theme }) => ({
  border: `1px solid rgba(255,255,255,0.4)`,
  borderRadius: 6,
  padding: theme.spacing(0.75, 1.5),
  backgroundColor: 'transparent',
  color: '#fff',
  cursor: 'pointer',
}))
